import styled from "styled-components";
import { Col, Row } from "antd";
import { ColSize } from "antd/lib/col";
import ScreenHelper from "components/Styled/ScreenHelper";


declare type ColSpanType = ColSize;

export const FiveSpanColLayout: { [key: string]: ColSpanType } = {
    xl: {
        span: 5,
        offset: 0,
    },
    lg: {
        span: 5,
        offset: 0,
    },
    md: {
        span: 5,
        offset: 0,
    },
    sm: {
        span: 10,
        offset: 0
    },
    xs: {
        span: 10,
        offset: 0
    }
};

export const FourSpanColLayout: { [key: string]: ColSpanType } = {
    xl: {
        span: 4,
        offset: 0,
    },
    lg: {
        span: 4,
        offset: 0,
    },
    md: {
        span: 4,
        offset: 0,
    },
    sm: {
        span: 10,
        offset: 1
    },
    xs: {
        span: 10,
        offset: 1
    },
};

export const TotalColLayout: { [key: string]: ColSpanType } = {
    xl: {
        span: 6,
        offset: 18,
    },
    lg: {
        span: 6,
        offset: 18,
    },
    md: {
        span: 6,
        offset: 18,
    },
    sm: {
        span: 6,
        offset: 15
    },
    xs: {
        span: 6,
        offset: 15
    },
};


export const TableCol = styled(Col)`

margin-bottom: 10px;

${ScreenHelper.down('sm', 'xs')`
  margin-bottom: 15px;
  `}
`;

export const HeaderCol = styled(Col)`
border-bottom: solid 1px lightgrey
`;

export const PaymentTotalHeaderCol = styled(Col)`
border-bottom: solid 1px black;
background-color: lightgray;
`;

export const PaymentTotalCol = styled(Col)`
background-color: lightgray;
`;

export const TableValueCol = styled(Col)`
height: 55px;

${ScreenHelper.down('sm', 'xs')`
height: inherit;
  `}

`;

export const HeaderTitle = styled.p`
float: left;
font-size: 20px;
font-weight: bold;
`;

export const PaymentRow = styled(Row)`
margin-bottom: 20px;
`;


